export default {
  title: 'Verificación de datos biométricos',
  titleDescription: 'Es necesario verificar la identidad del beneficiario para continuar',
  allowCamera: 'Permita el acceso a la camára en su navegador',
  tabs: {
    facial: 'Reconocimiento facial'
  },
  buttons: {
    capture: 'Capturar',
    retry: 'Volver a intentar',
    confirm: 'Confirmar'
  },
  biometricValidation: {
    success: 'Verificación exitosa',
    fail: 'Error en la verificación'
  },
  instructions: {
    title: 'Datos biométricos del beneficiario',
    subtitle: 'Es necesario capturar el rostro de la persona para verificar su identidad',
    buttonLabel: 'Comenzar',
    steps: {
      step1: {
        title: 'Paso 1',
        description: 'Coloque la cámara a la altura del rostro del asegurado'
      },
      step2: {
        title: 'Paso 2',
        description: 'Asegúrese de que haya luz suficiente'
      },
      step3: {
        title: 'Paso 3',
        description: 'Enmarque el rostro dentro de los límites mostrados'
      }
    }
  }
}